import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  { transform: 'translate(6 5)' },
  React.createElement('path', { d: 'M11,15a4,4,0,1,1,4-4A4,4,0,0,1,11,15ZM11,8a3,3,0,1,0,3,3A3,3,0,0,0,11,8Z' })
));